import React from 'react';
import { FormikProps } from 'formik';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AppFormSelectWrapper from '../../../components/designe/app-form-select-wrapper';

interface IAppFeaturesFilterProps {
  formik: FormikProps<any>;
  filterIsActiveOptions: Array<{ id: string | boolean; name: string }>;
}

export function AppFeaturesFilter(props: IAppFeaturesFilterProps) {
  const { formik, filterIsActiveOptions } = props;
  const { t } = useTranslation();

  return (
    <Grid container spacing={1}>
      <Grid item sm={4}>
        <AppFormSelectWrapper
          label={t('common.active')}
          name="isActive"
          options={filterIsActiveOptions}
          disableClear={false}
          formik={formik}
        />
      </Grid>
    </Grid>
  );
}
